import { render, staticRenderFns } from "./input-selector.vue?vue&type=template&id=87cfd536&scoped=true"
import script from "./input-selector.vue?vue&type=script&lang=js"
export * from "./input-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfd536",
  null
  
)

export default component.exports